
import React, { useState } from 'react';
import { Bell, TrendingDown, Target, Plus } from 'lucide-react';
import { motion } from 'framer-motion';

export function PriceTracker() {
  const [alerts, setAlerts] = useState([
    { id: 1, product: 'ASUS ROG Strix RTX 4080', currentPrice: 1199, targetPrice: 999, saved: 200 },
    { id: 2, product: 'Dell UltraSharp 4K Monitor', currentPrice: 499, targetPrice: 399, saved: 100 },
    { id: 3, product: 'Logitech MX Master 3', currentPrice: 89, targetPrice: 69, saved: 20 },
  ]);

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-4 sm:p-6 md:p-8 border border-slate-700"
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 text-center md:text-left items-center">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="bg-blue-500/20 p-3 rounded-xl">
            <Bell className="w-6 h-6 text-blue-400" />
          </div>
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-white">Price Tracker & Alerts</h2>
            <p className="text-sm sm:text-base text-slate-400">Get notified when prices drop</p>
          </div>
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="line-bg marquee-effect mt-4 md:mt-0 w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-sm sm:text-base text-white font-semibold py-2 px-4 rounded-lg transition-colors flex justify-center items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Add Alert
        </motion.button>
      </div>

      <div className="grid gap-4">
        {alerts.map((alert, index) => (
          <motion.div
            key={alert.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="bg-slate-700/50 rounded-xl p-4 border border-slate-600/50 hover:border-blue-500/50 transition-colors"
          >
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between text-center sm:text-left items-center">
              <div className="flex-1">
                <h3 className="text-white font-semibold">{alert.product}</h3>
                <div className="flex flex-col sm:flex-row sm:items-center gap-4 mt-2 justify-center sm:justify-start">
                  <div className="flex items-center gap-2 justify-center">
                    <span className="text-slate-400 text-sm">Current:</span>
                    <span className="text-white font-bold">${alert.currentPrice}</span>
                  </div>
                  <div className="flex items-center gap-2 justify-center">
                    <Target className="w-4 h-4 text-blue-400" />
                    <span className="text-slate-400 text-sm">Target:</span>
                    <span className="text-blue-400 font-bold">${alert.targetPrice}</span>
                  </div>
                </div>
              </div>
              <div className="mt-2 sm:mt-0 sm:text-right">
                <div className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm font-semibold">
                  ${alert.saved} saved
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
}
